module.exports = __webpack_public_path__ + "static/media/tutorial-banner.c263e8b0.png";